import React from "react";
import { Typography, Box, Chip } from "@mui/material";
import { SearchOff } from "@mui/icons-material";
import { useLocation } from 'react-router-dom';
import ErrorPageLayout from "./ErrorPageLayout";

/**
 * 404 Not Found Error Page
 * Replaces Django 404.html template
 */
export default function Error404(): React.ReactElement {
  const { pathname: currentPath } = useLocation();

  return (
    <ErrorPageLayout
      statusCode={404}
      title="Page Not Found"
      message="The page you're looking for doesn't exist or has been moved to a different location."
    >
      <Box sx={{ mb: 3 }}>
        <SearchOff sx={{ fontSize: 48, color: "text.secondary", mb: 2 }} />

        {currentPath && (
          <Box sx={{ mb: 2 }}>
            <Typography variant="body2" color="text.secondary">
              Requested path:
            </Typography>
            <Chip
              label={currentPath}
              variant="outlined"
              sx={{ mt: 1, fontFamily: "monospace" }}
            />
          </Box>
        )}

        <Typography variant="body2" color="text.secondary">
          The URL may be misspelled or the page may have been removed.
        </Typography>
      </Box>
    </ErrorPageLayout>
  );
}
